import can from 'can';
import Component from 'can/component/component';
import template from './table-statistics.stache';
import device from 'scripts/utils/device';
import _ from 'lodash';
import dtm from 'scripts/services/dtm';

const playerPageUrl = window.globalSettings.pagePaths.player;
const DEFAULT_SELECTION = [null, null];
const ALL_PLATFORMS_HEADERS = ['all', 'total', 'win'];
const SORTABLE_HEADERS = [
    'total',
    'off-the-tee',
    'approach',
    'short-game',
    'strokes-putting',
    'make-cut',
    'top-ten',
    'win',
    '1',
    '2',
    '3',
    '4',
];

Component.extend({
    tag: 'table-statistics',
    leakScope: false,
    template: template,
    viewModel: {
        selection: DEFAULT_SELECTION,
        define: {
            sortKey: {
                type: 'string',
                value: 'rank',
            },
            preLegend: {
                type: 'string',
                value: '',
            },
            preLegendTooltip: {
                type: 'string',
                value: '',
            },
            sortAsc: {
                type: 'boolean',
                value: true,
            },
            headers: {
                type: '*',
                set(headers) {
                    return headers.map((header) => ({
                        title: header.title,
                        value: header.value,
                        isDesktopOnly: !ALL_PLATFORMS_HEADERS.includes(
                            header.value,
                        ),
                        isSortable: SORTABLE_HEADERS.includes(header.value),
                    }));
                },
            },
            players: {
                type: '*',
            },
            firstPlayerId: {
                type: 'string',
                value: null,
            },
            secondPlayerId: {
                type: 'string',
                value: null,
            },
            totalCellIndex: {
                get() {
                    return _.findIndex(
                        this.attr('headers'),
                        (e) =>
                            e.value === 'total' ||
                            e.value === 'all' ||
                            e.value === 'win',
                    );
                },
            },
            notWebView: {
                get() {
                    return !_.get(window.globalSettings, 'inWebView');
                },
            },
            showComparisonPill: {
                type: 'boolean',
                value: false,
            },
        },

        getPlayerName(name) {
            if (name && typeof name === 'string') {
                return device.isPhone && !device.isTablet && !device.isNative
                    ? `${name.charAt(0)}.`
                    : name;
            }
        },

        playerDetailLink(playerId) {
            return can.sub(playerPageUrl, { playerId });
        },

        isCompareReady() {
            const selected = [
                this.attr('firstPlayerId'),
                this.attr('secondPlayerId'),
            ];

            return _.filter(selected, Boolean).length === 2;
        },

        isSelectedPlayer(playerId) {
            const selection = [
                this.attr('firstPlayerId'),
                this.attr('secondPlayerId'),
            ];
            return selection.some((selectedId) => playerId === selectedId);
        },

        isSelectable(player) {
            const isSelectionReady = this.isCompareReady();
            if (isSelectionReady) {
                const playerId = player.attr('player.identifier');
                return this.isSelectedPlayer(playerId);
            }

            const positionValue = player.attr('position');
            return (
                positionValue.startsWith('T') || Boolean(Number(positionValue))
            );
        },

        onTogglePlayer(event, $element, playerId) {
            event.stopPropagation();
            const isSelected = $element.is(':checked');

            if (isSelected) {
                this.handleSelectPlayer(playerId);
            } else {
                this.onResetPlayer(null, null, null, playerId);
            }
        },

        handleSelectPlayer(playerId) {
            if (!this.attr('firstPlayerId')) {
                this.attr('firstPlayerId', playerId);
            } else if (!this.attr('secondPlayerId')) {
                this.attr('secondPlayerId', playerId);
            }
        },

        onResetPlayer(context, element, type, playerId) {
            if (this.attr('firstPlayerId') === playerId) {
                this.attr('firstPlayerId', null);
            } else if (this.attr('secondPlayerId') === playerId) {
                this.attr('secondPlayerId', null);
            }
        },
    },

    events: {
        inserted() {
            this.viewModel.attr(
                'showComparisonPill',
                !window.globalSettings.inWebView &&
                    this.arePlayersAvailable(this.viewModel.attr('players')),
            );
            this.viewModel.bind('players', (__, players) => {
                const showComparisonPill = this.arePlayersAvailable(players);
                !window.globalSettings.inWebView &&
                    this.viewModel.attr(
                        'showComparisonPill',
                        showComparisonPill,
                    );
            });
        },

        arePlayersAvailable(players = []) {
            const availablePlayers = players.filter((player) =>
                this.viewModel.isSelectable(player),
            );

            return availablePlayers.length >= 2;
        },

        '.js-sorting-field click'(element, event) {
            const sortKey = element.attr('data-sort-key');
            can.batch.start();
            if (this.viewModel.attr('sortKey') === sortKey) {
                this.viewModel.attr('sortAsc', !this.viewModel.attr('sortAsc'));
            } else {
                this.viewModel.attr('sortKey', sortKey);
                this.viewModel.attr('sortAsc', true);
            }

            can.batch.stop();
            dtm.trackRoundTrackerClick(sortKey);
        },
    },
});
